import React, { useEffect } from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import EmployeeDataTable from "./EmployeeDataTable";
import { useDispatch } from "react-redux";
import {
  closeEmployeeModal,
  fetchEmployee,
  openEmployeeModal,
} from "./store/employeeSlice";
import { useSelector } from "react-redux";
import AddEmployee from "./AddEmployee";

const Employee = () => {
  const dispatch = useDispatch();
  const {
    data = [],
    loading = false,
    isModalOpen = false,
  } = useSelector((state) => state.employeeData || {});

  useEffect(() => {
    dispatch(fetchEmployee());
  }, [dispatch]);

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Employee"
            title="Dashboard"
            subtitle="Employee"
            name="Import Employee"
            onAddClick={() => dispatch(openEmployeeModal())}
          />

          <EmployeeDataTable data={data} loading={loading} />

          <AddEmployee
            show={isModalOpen}
            onClose={() => dispatch(closeEmployeeModal())}
          />
        </div>
      </div>
    </div>
  );
};

export default Employee;
